module.exports = __webpack_public_path__ + "static/media/Keith-Sewell-Headshot.3d63d229.jpeg";